<script lang="ts">
  import { ProductWizardTextField } from '@athena-lib/Fields';
  import clsx from 'clsx';
  import { Popover } from '@athena-lib/Popover';
  import { Text } from '@athena-lib/Text';
  import type { SizeBoxProps, SizeUpdatedEvent } from './types';

  let widthInvalid: boolean = $state(false);
  let heightInvalid: boolean = $state(false);

  const {
    step,
    max,
    min,
    width,
    height,
    size,
    tooltip,
    translations,
    class: classList,
    onChange,
  }: SizeBoxProps = $props();

  const idWidth = Math.floor(Math.random() * 10000).toString();
  const idHeight = Math.floor(Math.random() * 10000).toString();

  const onBlur = (event: Event, attributeName: string) => {
    let measure: number = parseFloat((event.target as HTMLInputElement).value);

    if (isNaN(measure)) {
      measure = min;
    } else if (measure < min) {
      measure = min;
    } else if (measure > max) {
      measure = max;
    }

    (event.target as HTMLInputElement).value = measure.toString();
    onInput(event, attributeName);
  };

  const onInput = (event: Event, attributeName: string) => {
    let measure: number = parseFloat((event.target as HTMLInputElement).value);
    widthInvalid = false;
    heightInvalid = false;
    if (tooltip && (isNaN(measure) || measure < min)) {
      switch (attributeName) {
        case 'width_mm':
          widthInvalid = true;
          break;
        case 'height_mm':
          heightInvalid = true;
          break;
      }
      return;
    }

    const payload: SizeUpdatedEvent = {
      size: '' as string, //E.g. 2x2
      customValue: {
        name: attributeName,
        measure: measure,
      },
    };
    if (onChange) {
      onChange(payload);
    }
  };

  const getTranslation = () => {
    if (!translations) {
      return `${min} - ${max}`;
    }
    return translations['tooltip_error_size']
      .replace('$1', min.toString())
      .replace('$2', max.toString())
      .toString();
  };

  const widthClass = $derived.by(() => {
    const widthClasses: Record<string, string> = {
      small: clsx('w-full max-w-48'),
      medium: clsx('w-full max-w-64'),
      large: clsx('w-full'),
    };

    return widthClasses[size];
  });
</script>

<div class={clsx(widthClass, 'flex items-end')}>
  <Popover
    class="w-full"
    floater={widthInvalid ? getTranslation() : undefined}
    trigger="always"
    placement="bottom"
  >
    <ProductWizardTextField
      class={'rounded-none rounded-s-md border-r-0'}
      type="number"
      {step}
      value={width}
      id={idWidth}
      onChange={(event: Event) => onInput(event, 'width_mm')}
      onBlur={(event: Event) => onBlur(event, 'width_mm')}
      {min}
      {max}
    />
  </Popover>
  <div class={clsx(classList, 'border px-3 py-2')}>
    <Text>x</Text>
  </div>
  <Popover
    class="w-full"
    floater={heightInvalid ? getTranslation() : undefined}
    trigger="always"
    placement="bottom"
  >
    <ProductWizardTextField
      class={'rounded-none rounded-e-md border-l-0'}
      type="number"
      {step}
      value={height}
      id={idHeight}
      onInput={(event: Event) => onInput(event, 'height_mm')}
      onBlur={(event: Event) => onBlur(event, 'height_mm')}
      {min}
      {max}
    />
  </Popover>
</div>
